import smoothscroll from "smoothscroll-polyfill";
import lozad from "lozad";
import hamburger from "./../part/hamburger";
import AOS from 'aos';
import modal from "./../part/modal"
import modalRequest from "./../part/modalRequest"
import slider from "../part/slider";

export default {
	init() {
		// JavaScript to be fired on all pages

		// kick off the polyfill!
		smoothscroll.polyfill();

		// Hamburger event listener
		hamburger();

		// Lazy load image with lozad.js https://github.com/ApoorvSaxena/lozad.js
		const lazyObserver = lozad(); // lazy loads elements with default selector as '.lozad'
		lazyObserver.observe();

		// AOS
		AOS.init({
        easing: 'ease-in',
        duration: 700,
        delay: 0,
        once: true,
        // disable: 'mobile'
    });




    const hasSlider = document.querySelector('.block-slider');
    if (typeof(hasSlider ) != 'undefined' && hasSlider  != null){
      slider()
    }


		// MODAL
		modal();
		// MODAL REQUEST
		modalRequest();

		// ########## VUE APP ##########
		// const vueModal = new Vue({
		// 	el: '#vueModal',
		// 	data: {
		// 	  message: 'Hello Vue!'
		// 	},
		// 	mounted() {
		// 		console.log('mounted');
		// 	},
		//   })

	},

	finalize() {
		// JavaScript to be fired on all pages, after page specific JS is fired
	},
};
